import { RouterContext } from '../../gs-component-right-rail';
import React, { useContext } from 'react';

import { ApiClientsContext } from '../components/ApiClientsContext';
import { EventItem } from '../components/EventItem';
import RightRailSection from '../components/RightRailSection';
import { FormValues } from './RightRailForm';

interface Props {
  values: FormValues;
}

export const ScheduleOfEventsForm: React.FC<Props> = ({ values }) => {
  const { gdsEvent: events } = useContext(ApiClientsContext);
  const { push } = useContext(RouterContext);

  return (
    <RightRailSection name="Schedule of Events">
      {Array.isArray(events) &&
        events.map((event, index) => {
          const eventName = event.type.toLowerCase() === 'ceremony' ? 'Ceremony' : event.name;
          return (
            <EventItem
              name={eventName}
              venueName={values.events && values.events[index] && values.events[index].location.name}
              key={event.id}
              showTime={false}
              onClick={(): void => push({ screen: 'subEvent', params: { eventType: event.type, eventIndex: index } })}
            />
          );
        })}
    </RightRailSection>
  );
};
